import React from 'react';
import { API } from 'aws-amplify';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CommonFunctions from './RegCommon/CommonFunctions';
import TravconFunctions from './RegCommon/CustomerFunctions/TravconFunctions';
import EventcodeFunctions from './RegCommon/EventcodeFunctions';
import RegItemStrings from './RegCommon/RegItemStrings';
var serviceNames = require('../ServiceNameMapper');

var moment = require('moment-timezone');

var successcheckmsg = '';
var successcardmsg = '';
var successpayrollmsg = '';
var successfree = '';
var updatemsg = '';
var errormsg = '';
var successachmsg = "";
var successrazorpaymsg = "";
var registered = false;

class RegisterAttendee extends React.Component {
    constructor(props) {
        super(props);
        //console.log(props);
        this.state = {
            code: global.$code,
            s3: global.$s3,
            bucket: global.$s3bucket,
            isLoading: false,
            q1: " ",
            q2: " ",
            q3: " ",
            q4: " ",
            q5: " ",
            q6: " ",
            q7: " ",
            q8: " ",
            showdirectory: " ",
            message: '',
            selectedpayment: '',
            regattendeesuccess: false,
            regguestsuccess: false,
            totalamount: 0,
            amountpaid: 0,
            amountpending: 0,
            guestname: '',
            attendeeregistration: false,
            guestregistration: false,
            orderid: ' ',
            paymentid: ' ',
            signature: ' ',
            hideSpinner: false,
            showloginlink: true
        };
    }

    render() {
        //console.log("regattendee render");
        //console.log(this.props);
        //console.log(global.$registrationform);
        if (global.$registrationform.messages != null) {
            successcardmsg = global.$registrationform.messages.successcard;
            successcheckmsg = global.$registrationform.messages.successcheck;
            successpayrollmsg = global.$registrationform.messages.successpayroll;
            updatemsg = global.$registrationform.messages.successupdate;
            successfree = global.$registrationform.messages.successfree;
            errormsg = global.$registrationform.messages.failure;

            if (global.$registrationform.messages.successachmsg != null) {
                successachmsg = global.$registrationform.messages.successachmsg;
            }
            if (global.$registrationform.messages.successrazorpaymsg != null) {
                successrazorpaymsg = global.$registrationform.messages.successrazorpaymsg;
            }

            if (global.$registrationform.messages.showloginmessage != null) {
                this.state.showloginlink = global.$registrationform.messages.showloginmessage;
            }
        }
        if (Number(global.$regamount) == 0) {
            this.state.selectedpayment = "Free Regsitration";
        }
        else {
            this.state.selectedpayment = global.$selectedPaymentOption;
        }
        //console.log(this.state.regattendeesuccess, this.state.regguestsuccess);
        //console.log(global.$isattendeeregistered, global.$isguestregistered);
        //console.log(global.$regdiscountinfo);
        //console.log(this.state.hideSpinner) 
        //console.log(this.state.attendeeregistration, global.$isattendeeregistered, this.props.regattendeestatus)
        return (
            <div>
                <div className="loading-button-div"
                >
                    <Spinner
                        animation="border"
                        role="status"
                        size="sm"
                        hidden={this.state.hideSpinner}
                        className="loading-button-register"
                    />
                </div>
                <div className="payment-message" id="message"></div>
                {
                    registered == true ?
                        (
                            CommonFunctions.isUserLoggedin() ?
                                (
                                    ''
                                )
                                :
                                (
                                    global.$deferredpromo == "Y" ?
                                        ('')
                                        :
                                        (
                                            this.state.showloginlink == true ?
                                                (
                                                    <p className="payment-login"><Link to={`/LoginForm`}>Click here to login</Link></p>
                                                )
                                                :
                                                ('')
                                        )
                                )
                        )
                        :
                        ('')
                }

                {   // Check if attendee is registered or not. Attendee will be registered first
                    global.$isattendeeregistered == null && global.$isattendeeregistered != true ?
                        (
                            // this.props.regattendeestatus == true ?
                            //     (
                            this.state.attendeeregistration == false ?
                                (
                                    this.addAttendee(global.$regattendeeinfo, "attendee")
                                )
                                :
                                ('')
                            // )
                            // :
                            // ('')
                        )
                        :
                        ('')
                }
                {
                    global.$isguestregistered == null && global.$isguestregistered != true ?
                        (
                            this.props.reggueststatus == true ?
                                (
                                    <div>
                                        {console.log(global.$isguestregistered)}
                                        {
                                            this.state.guestregistration == false ?
                                                (
                                                    this.addAttendee(global.$regguestinfo, "guest")
                                                )
                                                :
                                                ('')
                                        }
                                    </div>
                                )
                                :
                                ('')
                        )
                        :
                        ('')
                }
            </div>
        );
    }

    
    addAttendee(attendeeinfo, user) {

        try {

        //console.log(this.state.guestregistration, this.state.reggueststatus, global.$isguestregistered)
        //console.log("adding =" + user);
        //console.log(attendeeinfo);
        //let apiName = 'WebsiteService';
        let apiName = serviceNames.getRegistrationService();
        let path = ''; //replace this with the path you have configured on your API

        var date = new Date();
        var longFormat = date / 1000;
        var timestamp = date / 1000;
        longFormat = longFormat.toString();
        longFormat = longFormat.replace(/\./g, "");
        //console.log(longFormat);
        //console.log(longFormat.length - 10, longFormat.length);
        var regid = longFormat.substring(longFormat.length - 10, longFormat.length);
        //console.log(regid);
        var password = regid;

        if (global.$code == "metro2022conference") {
            password = "MeTro2022";
        }

        if (global.$code == "metro2023convention") {
            password = "MeTro2023";
        }

        if (global.$code == "aicup2022") {
            password = "AiCuP2022";
        }

        if (global.$code == "aslatx2022") {
            password = "aslatx2022";
        }

        //console.log(global.$guestregitems.toString());
        //console.log(global.$attendeeregitems.toString());
        var regitems = '';
        //console.log(regitems);
        //console.log(user)
        if (user == "attendee") {
            this.setState({ attendeeregistration: "inprogress" });
            if (global.$guestexist == true && global.$guestfname != null) {
                this.state.guestname = global.$guestfname + " " + global.$guestlname;
            }
            //console.log(regitems);
            //console.log(global.$attendeeregitems)
            // Check to update the regitems
            if (global.$guestregitems != null && global.$regguestinfo != "") {
                if (global.$regdiscountinfo != null && global.$regdiscountinfo != "") {
                    if (global.$guestregitems != "" && global.$guestregitems != " ") {
                        regitems = global.$totalregitems.toString() + ",Promo or Deferral - $" + global.$regdiscountinfo.discountprice;
                        //console.log(regitems);
                    }
                    else {
                        regitems = global.$totalregitems.toString() + ",Promo or Deferral - $" + global.$regdiscountinfo.discountprice;
                        //console.log(regitems);
                    }
                }
                else {
                    if (CommonFunctions.isUserLoggedin()) {
                        if (global.$guestexist != null && global.$guestexist == true) {
                            regitems = global.$guestregitems.toString();
                        }
                        else {
                            regitems = global.$totalregitems.toString();
                        }
                        //console.log(regitems);
                    }
                    else {
                        regitems = global.$totalregitems.toString();
                        //console.log(regitems);
                    }
                }
            }
            else {
                if (global.$totalregitems != null) {

                    regitems = global.$totalregitems.toString();
                    //console.log(regitems);
                }
            }
        }
        else if (user == "guest") {
            //console.log(user)
            //console.log(global.$guestregitems)
            this.setState({ guestregistration: "inprogress" });
            regitems = global.$guestregitems.toString();
        }
        //console.log(regitems);

        if (attendeeinfo.fname == "") {
            attendeeinfo.fname = " ";
        }
        if (attendeeinfo.lname == "") {
            attendeeinfo.lname = " ";
        }
        if (attendeeinfo.phone == "") {
            attendeeinfo.phone = " ";
        }
        if (attendeeinfo.memberid == "") {
            attendeeinfo.memberid = " ";
        }
        if (attendeeinfo.company == "") {
            attendeeinfo.company = " ";
        }
        if (attendeeinfo.title == "") {
            attendeeinfo.title = " ";
        }
        if (attendeeinfo.officephone == "") {
            attendeeinfo.officephone = " ";
        }
        if (attendeeinfo.street == "") {
            attendeeinfo.street = " ";
        }
        if (attendeeinfo.city == "") {
            attendeeinfo.city = " ";
        }
        if (attendeeinfo.zip == "") {
            attendeeinfo.zip = " ";
        }
        if (attendeeinfo.state == "") {
            attendeeinfo.state = " ";
        }
        if (attendeeinfo.country == "") {
            attendeeinfo.country = " ";
        }
        if (attendeeinfo.location == "" || attendeeinfo.location == null) {
            //console.log(moment.tz.guess());
            attendeeinfo.location = moment.tz.guess();
        }
        if (attendeeinfo.linkedin == "") {
            attendeeinfo.linkedin = " ";
        }
        if (attendeeinfo.facebook == "") {
            attendeeinfo.facebook = " ";
        }
        if (attendeeinfo.twitter == "") {
            attendeeinfo.twitter = " ";
        }
        if (attendeeinfo.myexpertise == "") {
            attendeeinfo.myexpertise = " ";
        }
        if (attendeeinfo.myinterests == "") {
            attendeeinfo.myinterests = " ";
        }
        if (attendeeinfo.data1 == "") {
            attendeeinfo.data2 = " ";
        }
        if (attendeeinfo.data3 == "") {
            attendeeinfo.data3 = " ";
        }
        if (attendeeinfo.lastseen == "") {
            attendeeinfo.lastseen = " ";
        }
        if (attendeeinfo.poolid == "" || attendeeinfo.poolid == null) {
           //console.log(global.$settings)
            attendeeinfo.poolid = global.$settings.poolids.userpoolid;
        }
        if (attendeeinfo.submittedby == "") {
            attendeeinfo.submittedby = " ";
        }
        if (attendeeinfo.validscans == "") {
            attendeeinfo.validscans = " ";
        }
        if (attendeeinfo.password == "") {
            attendeeinfo.password = password;
        }
        if (attendeeinfo.regid == "") {
            attendeeinfo.regid = regid;
        }
        if (attendeeinfo.regid == "") {
            attendeeinfo.regid = regid;
        }
        if (attendeeinfo.regtype == "") {
            attendeeinfo.regtype = regitems;
        }
        if (attendeeinfo.mname == "") {
            attendeeinfo.mname = " ";
        }
        if (attendeeinfo.locationtime == "") {
            attendeeinfo.locationtime = moment.tz(attendeeinfo.location).format('mm/dd/yyyy hh:mm:ss A');
        }
        if (attendeeinfo.signindate == "") {
            attendeeinfo.signindate = " ";
        }
        //console.log(global.$reguestemail);
        //console.log(global.$guestexist, global.$reguestemail)
        //console.log(attendeeinfo);
        if (attendeeinfo.guests == "" || attendeeinfo.guests == " ") {
            //console.log(global.$guestexist, global.$reguestemail)
            if (user == "attendee") {
                if (global.$guestexist == true) {
                    //console.log(global.$guestexist, global.$reguestemail)
                    if (global.$reguestemail != null) {
                        //console.log(global.$guestexist, global.$reguestemail)
                        attendeeinfo.guests = global.$reguestemail;
                    }
                    else {
                        attendeeinfo.guests = " ";
                    }
                }
            }
        }
        //console.log(attendeeinfo);
        if (attendeeinfo.sessions == "") {
            attendeeinfo.sessions = " ";
        }
        if (attendeeinfo.checkinstatus == "") {
            attendeeinfo.checkinstatus = " ";
        }
        if (attendeeinfo.regnotes == "") {
            attendeeinfo.regnotes = " ";
        }
        if (attendeeinfo.photo == "") {
            attendeeinfo.photo = "common_profile.png";
        }


        // Check to update the question fields
        if (global.$regquestionsinfo != null) {
            if (global.$regquestionsinfo.question1 == "Select") {
                global.$regquestionsinfo.question1 = " ";
            }
            if (global.$regquestionsinfo.question2 == "Select") {
                global.$regquestionsinfo.question2 = " ";
            }
            if (global.$regquestionsinfo.question3 == "Select") {
                global.$regquestionsinfo.question3 = " ";
            }
            if (global.$regquestionsinfo.question4 == "Select") {
                global.$regquestionsinfo.question4 = " ";
            }
            if (global.$regquestionsinfo.question5 == "Select") {
                global.$regquestionsinfo.question5 = " ";
            }
            if (global.$regquestionsinfo.question6 == "Select") {
                global.$regquestionsinfo.question6 = " ";
            }
            if (global.$regquestionsinfo.question7 == "Select") {
                global.$regquestionsinfo.question7 = " ";
            }
            if (global.$regquestionsinfo.question8 == "Select") {
                global.$regquestionsinfo.question8 = " ";
            }
            if (global.$regquestionsinfo.question1 != "" && global.$regquestionsinfo.question1value == "") {
                this.state.q1 = 'q#title:' + global.$regquestionsinfo.question1title + ';answer:' + global.$regquestionsinfo.question1;
                if (global.$code == "wspma2021") {
                    //console.log(global.$regquestionsinfo.question1);
                    if (global.$regquestionsinfo.question1 == "Yes") {
                        this.state.showdirectory = "true";
                    }
                    else {
                        this.state.showdirectory = "false";
                    }
                    //console.log(this.state.showdirectory)
                }
            }
            else if (global.$regquestionsinfo.question1value != "") {
                this.state.q1 = 'q#title:' + global.$regquestionsinfo.question1title + ';answer:' + global.$regquestionsinfo.question1value;
            }

            if (global.$regquestionsinfo.question2 != "" && global.$regquestionsinfo.question2value == "") {
                this.state.q2 = 'q#title:' + global.$regquestionsinfo.question2title + ';answer:' + global.$regquestionsinfo.question2;
            }
            else if (global.$regquestionsinfo.question2value != "") {
                this.state.q2 = 'q#title:' + global.$regquestionsinfo.question2title + ';answer:' + global.$regquestionsinfo.question2value;
            }

            if (global.$regquestionsinfo.question3 != "" && global.$regquestionsinfo.question3value == "") {
                this.state.q3 = 'q#title:' + global.$regquestionsinfo.question3title + ';answer:' + global.$regquestionsinfo.question3;
            }
            else if (global.$regquestionsinfo.question3value != "") {
                this.state.q3 = 'q#title:' + global.$regquestionsinfo.question3title + ';answer:' + global.$regquestionsinfo.question3value;
            }

            if (global.$regquestionsinfo.question4 != "" && global.$regquestionsinfo.question4value == "") {
                this.state.q4 = 'q#title:' + global.$regquestionsinfo.question4title + ';answer:' + global.$regquestionsinfo.question4;
            }
            else if (global.$regquestionsinfo.question4value != "") {
                this.state.q4 = 'q#title:' + global.$regquestionsinfo.question4title + ';answer:' + global.$regquestionsinfo.question4value;
            }

            if (global.$regquestionsinfo.question5 != "" && global.$regquestionsinfo.question5value == "") {
                this.state.q5 = 'q#title:' + global.$regquestionsinfo.question5title + ';answer:' + global.$regquestionsinfo.question5;
            }
            else if (global.$regquestionsinfo.question5value != "") {
                this.state.q5 = 'q#title:' + global.$regquestionsinfo.question5title + ';answer:' + global.$regquestionsinfo.question5value;
            }

            if (global.$regquestionsinfo.question6 != "" && global.$regquestionsinfo.question6value == "") {
                this.state.q6 = 'q#title:' + global.$regquestionsinfo.question6title + ';answer:' + global.$regquestionsinfo.question6;
            }
            else if (global.$regquestionsinfo.question6value != "") {
                this.state.q6 = 'q#title:' + global.$regquestionsinfo.question6title + ';answer:' + global.$regquestionsinfo.question6value;
            }

            if (global.$regquestionsinfo.question7 != "" && global.$regquestionsinfo.question7value == "") {
                this.state.q7 = 'q#title:' + global.$regquestionsinfo.question7title + ';answer:' + global.$regquestionsinfo.question7;
            }
            else if (global.$regquestionsinfo.question7value != "") {
                this.state.q7 = 'q#title:' + global.$regquestionsinfo.question7title + ';answer:' + global.$regquestionsinfo.question7value;
            }

            if (global.$regquestionsinfo.question8 != "" && global.$regquestionsinfo.question8value == "") {
                this.state.q8 = 'q#title:' + global.$regquestionsinfo.question8title + ';answer:' + global.$regquestionsinfo.question8;
            }
            else if (global.$regquestionsinfo.question8value != "") {
                this.state.q8 = 'q#title:' + global.$regquestionsinfo.question8title + ';answer:' + global.$regquestionsinfo.question8value;
            }
        }
        var mailstatus = "new";
        var regstatus = 'Confirmed';
        var emailtype = '';
        var paymentstatus = '';


        // check to update the payment and regtype fields
        if (CommonFunctions.isUserLoggedin()) {
            mailstatus = 'update';

            var commonstrings = RegItemStrings.commonConstants;
            //console.log(commonstrings);
            if (user == "attendee") {
                //console.log(global.$regamount, attendeeinfo.totalamount, Number(global.$regamount), Number(attendeeinfo.totalamount))
                this.state.totalamount = Number(global.$regamount) + Number(attendeeinfo.totalamount);
                this.state.refundamount = Number(attendeeinfo.refundamount);
                this.state.amountpending = Number(attendeeinfo.pendingamount);
                this.state.amountpaid = Number(attendeeinfo.amountpaid);
                //console.log(this.state.totalamount);
                //console.log(attendeeinfo.regtype);
                //console.log(regitems);

                // add the new regitems to the old regitems
                if (regitems.includes("Booth Registration") || regitems.includes("Booth Bundle Registration")) {
                    var result = TravconFunctions.replaceRegItemsForRegUpgrade(global.$code, attendeeinfo.regtype, regitems);
                   //console.log(result);
                    var upgrade = "Booth Upgrade - $" + global.$upgradepricediff;

                    regitems = regitems + "," + upgrade;

                    attendeeinfo.regtype = result + "," + regitems;
                }
                else if (regitems.includes(commonstrings.mainstageticket) || regitems.includes(commonstrings.newbiebootcamp) || regitems.includes(commonstrings.medicalspanishsun) || regitems.includes(commonstrings.medicalspanishwed) ||  regitems.includes(commonstrings.travcon2023medicalspanishsun) || regitems.includes(commonstrings.travcon2023medicalspanishwed)) {
                    var result = TravconFunctions.replaceRegItemsForRegUpgrade(global.$code, attendeeinfo.regtype, regitems);
                    //console.log(result);
                    //console.log(regitems);
                    var upgrade = "Upgrade - $" + global.$upgradepricediff;

                    regitems = regitems + "," + upgrade;

                    attendeeinfo.regtype = result + "," + regitems;
                }
                else {
                    //console.log(regitems);
                    attendeeinfo.regtype = attendeeinfo.regtype + "," + regitems;
                }
                //console.log(attendeeinfo.regtype);
                //console.log(global.$selectedPaymentOption,global.$regamount, global.$deferredpromo, global.$deferredpromoamount, this.state.amountpending);
                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                        if (global.$deferredpromoamount != null) {
                            if (global.$code == "travcon2022exhibitor" || global.$code == "travcon2023exhibitor") {
                                this.state.amountpending = Number(global.$deferredpromoamount);
                            }
                            else {
                                this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                            }
                        }
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                    if (regitems == "" || regitems == " ") {
                        this.state.amountpending = Number(attendeeinfo.pendingamount);
                    }
                    else {
                        this.state.amountpending = Number(global.$regamount);
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                    if (regitems == "" || regitems == " ") {
                        this.state.amountpending = Number(attendeeinfo.pendingamount);
                    }
                    else {
                        this.state.amountpending = Number(global.$regamount);
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                    //console.log("regitems: " + regitems);
                    if (regitems == "" || regitems == " ") {
                        this.state.amountpending = Number(attendeeinfo.pendingamount);
                    }
                    else {
                        this.state.amountpending = Number(global.$regamount);
                    }

                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            if (global.$code == "travcon2022exhibitor" || global.$code == "travcon2023exhibitor") {
                                this.state.amountpending = Number(global.$deferredpromoamount);
                            }
                            else {
                                this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                            }
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("ACH")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            if (global.$code == "travcon2022exhibitor" || global.$code == "travcon2023exhibitor") {
                                this.state.amountpending = Number(global.$deferredpromoamount);
                            }
                            else {
                                this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                            }
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Online")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                }
            }
            else if (user == "guest") {
                this.state.totalamount = Number(attendeeinfo.totalamount);
                this.state.refundamount = Number(attendeeinfo.refundamount);
                this.state.amountpending = Number(attendeeinfo.pendingamount);
                this.state.amountpaid = Number(attendeeinfo.amountpaid);
                //console.log(regitems);
                //console.log(attendeeinfo);
                attendeeinfo.regtype = regitems;
                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
            }
        }
        else {
            if (user == "attendee") {
                //this.state.totalamount = global.$totalamount
                //console.log(global.$regamount, attendeeinfo.totalamount, Number(global.$regamount), Number(attendeeinfo.totalamount))

                //console.log(this.state.totalamount);
                this.state.totalamount = global.$regamount

                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                    this.state.amountpaid = 0;
                    this.state.amountpending = global.$regamount;
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                    this.state.amountpaid = 0;
                    this.state.amountpending = global.$regamount;
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                    this.state.amountpaid = 0;
                    this.state.amountpending = global.$regamount;
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("ACH")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Online")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
            }
            else if (user == "guest") {

                this.state.amountpaid = 0;
                this.state.amountpending = 0;
                this.state.totalamount = 0;
                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
            }
        }

        // Check to update the regstatus
        if (global.$selectedPaymentOption.includes("Check") || global.$selectedPaymentOption.includes("Payroll") || global.$selectedPaymentOption.includes("Pay Later")) {
            regstatus = "Pending";
        }
        else {
            if (global.$deferredpromo == "Y") {
                regstatus = "Confirmed";
            }
            else {
                regstatus = "Confirmed";
            }
        }


        //console.log(user, this.props.type);
        //console.log(attendeeinfo);
        var usertype = "attendee";
        if (user == "attendee") {
            if (this.props.type == "attendee") {
                emailtype = "primaryattendee";
                usertype = "Attendee";
            }
            else if (this.props.type == "sponsor") {
                emailtype = "primarysponsor";
                usertype = "Sponsor";
                //usertype = "Exhibitor";
            }
            else if (this.props.type == "exhibitor") {
                emailtype = "primaryexhibitor";
                //usertype = "Sponsor";
                usertype = "Exhibitor";
                
                if(attendeeinfo.userstype == "Exhibitor Admin"){
                    usertype = "Exhibitor Admin";
                }
            }
        }
        else if (user == "guest") {
            if (this.props.type == "attendee") {
                emailtype = "primaryguest";
                usertype = "Guest"
            }
            else if (this.props.type == "sponsor") {
                emailtype = "guestsponsor";
                //usertype = "Sponsor";
                usertype = "Exhibitor";
            }
            else if (this.props.type == "exhibitor") {
                emailtype = "primaryexhibitor";
                //usertype = "Sponsor";
                usertype = "Exhibitor";

                if(attendeeinfo.userstype == "Exhibitor Admin"){
                    usertype = "Exhibitor Admin";
                }

            }
        }
        //console.log(usertype)
        if (global.$regamount == 0) {
            global.$selectedPaymentOption = "No Payment";
            if (user == "attendee") {
                if (global.$deferredpromo == "N") {
                    regstatus = "Pending"
                }
            }

        }

        var promocode = ' ';
        var promoamount = '0';
        var regpromocodesforsignupcount = "";
        //console.log(global.$regdiscountinfo);
        //console.log(promocode);
        if (global.$regdiscountinfo != null && global.$regdiscountinfo != "" && global.$regdiscountinfo != " ") {
            if (global.$regdiscountinfo.discountvalue != null) {
                promocode = global.$regdiscountinfo.discountvalue;
                regpromocodesforsignupcount = global.$regdiscountinfo.discountvalue;
            }
            if (global.$regdiscountinfo.discountprice != null) {
                if (global.$deferredpromo != "Y") {
                    promoamount = global.$regdiscountinfo.discountprice;
                }
            }
        }

        if (CommonFunctions.isUserLoggedin()) {
            if (user == "attendee") {
                regstatus = attendeeinfo.regstatus;
                if (attendeeinfo.promocodes != null && attendeeinfo.promocodes != "" && attendeeinfo.promocodes != " ") {
                    attendeeinfo.promocodes = attendeeinfo.promocodes.trim();
                    promocode = attendeeinfo.promocodes + "," + promocode;
                }
                promoamount = Number(attendeeinfo.promoamount) + Number(promoamount);
            }
        }
        else {
            if (global.$deferredpromo == "Y") {
                regstatus = "Confirmed";
            }
        }
        //console.log(attendeeinfo.showdirectory)
        this.state.showdirectory = attendeeinfo.showdirectory
        //console.log(this.state.showdirectory);
        if (this.state.showdirectory == " ") {
            this.state.showdirectory = "true";
        }
        //console.log(promocode);

        if (attendeeinfo.data1 == "") {
            attendeeinfo.data1 = " ";
        }
        if (attendeeinfo.data2 == "") {
            attendeeinfo.data2 = " ";
        }
        if (attendeeinfo.data3 == "") {
            attendeeinfo.data3 = " ";
        }
        if (attendeeinfo.data4 == "") {
            attendeeinfo.data4 = " ";
        }
        if (attendeeinfo.data5 == "") {
            attendeeinfo.data5 = " ";
        }
        if (attendeeinfo.service == "") {
            attendeeinfo.service = " ";
        }
        if (attendeeinfo.desc == "") {
            attendeeinfo.desc = " ";
        }
        if (attendeeinfo.guests == "") {
            attendeeinfo.guests = " ";
        }
        if (this.state.guestname == "") {
            this.state.guestname = " ";
        }
        if (attendeeinfo.url == "") {
            attendeeinfo.url = " ";
        }

        if (user == "guest") {
            promoamount = '0';
            promocode = " ";
            this.state.guestname = " ";
        }


        /// Added this check for metro automatic badge In-Person/Virtual
        if (CommonFunctions.isUserLoggedin()) {
            if (user == "guest") {
                if (global.$guestregitems.toString().includes("In-Person")) {
                    attendeeinfo.data4 = "In-Person";
                }
                else if (global.$guestregitems.toString().includes("Virtual")) {
                    attendeeinfo.data4 = "Virtual";
                }
            }
        }
        else {

            if (user == "attendee") {
                if (global.$attendeeregitems.toString().includes("In-Person")) {
                    attendeeinfo.data4 = "In-Person";
                }
                else if (global.$attendeeregitems.toString().includes("Virtual")) {
                    attendeeinfo.data4 = "Virtual";
                }
            }
            else if (user == "guest") {
                if (global.$guestregitems.toString().includes("In-Person")) {
                    attendeeinfo.data4 = "In-Person";
                }
                else if (global.$guestregitems.toString().includes("Virtual")) {
                    attendeeinfo.data4 = "Virtual";
                }
            }
        }
        attendeeinfo.email = (attendeeinfo.email).trim();
        attendeeinfo.email = (attendeeinfo.email).toLowerCase();

        global.$regemail = (global.$regemail).trim();
        global.$regemail = (global.$regemail).toLowerCase();

        if (paymentstatus == "free") {
            regstatus = "Confirmed";
        }
        //console.log(promoamount)

        // if (promoamount == 0) {
        //     promocode = " ";
        // }
        var dateregistered = new Date(timestamp * 1000).toLocaleString();

        if (CommonFunctions.isUserLoggedin()) {
            dateregistered = attendeeinfo.data5;
        }
        //console.log(dateregistered);
        //console.log(global.$regamount, global.$code, global.$selectedPaymentOption); 
        if (global.$transactionfee != null && global.$transactionfee != "" && global.$regamount > 0 && this.isTravconExhibitor(global.$code) && global.$selectedPaymentOption.includes("Credit")) {
            regitems = regitems + ",Transaction Fee - $" + global.$transactionfee;
            attendeeinfo.regtype = attendeeinfo.regtype + ",Transaction Fee - $" + global.$transactionfee;
        }

        var category = regitems;
        var splevel = regitems;
        if (this.props.type == "exhibitor" || this.props.type == "sponsor") {
            category = " ";
            splevel = " "
        }
        // if (Number(this.state.totalamount) == Number(0)) {
        //    //console.log(this.state.totalamount);
        //     this.state.totalamount = global.$totalamount;
        //    //console.log(this.state.totalamount);
        // }
        //console.log(this.state.totalamount);
        this.state.totalamount = parseFloat(this.state.totalamount).toFixed(2);
        //console.log(this.state.totalamount);
        this.state.amountpaid = parseFloat(this.state.amountpaid).toFixed(2);
        this.state.amountpending = parseFloat(this.state.amountpending).toFixed(2);
        promoamount = parseFloat(promoamount).toFixed(2);

        if (global.$code == "afpikar2021") {
            if (global.$paymentid != null) {
                this.state.paymentid = global.$paymentid;
            }
        }
        //console.log(attendeeinfo)
        if(EventcodeFunctions.isTravconAttendee(global.$code) && user == "attendee"){
            this.state.guestname = attendeeinfo.guestname;
        }
        //console.log(attendeeinfo)
        if (global.$regitemtoreducecount == null) {
            global.$regitemtoreducecount = " ";
        }
        if (global.$regItemsForSignupCount == null) {
            global.$regItemsForSignupCount = " "
        }

        let myInit =
        {
            body:
            {
                'code': global.$code,
                // 'command': 'addUserProfile',
                'command': 'processRegistration',
                'userid': attendeeinfo.email,
                'fname': attendeeinfo.fname,
                'lname': attendeeinfo.lname,
                'company': attendeeinfo.company,
                'title': attendeeinfo.title,
                'phone': attendeeinfo.phone,
                'email': attendeeinfo.email,
                'linkedin': attendeeinfo.linkedin,
                'twitter': attendeeinfo.twitter,
                'fb': attendeeinfo.facebook,
                'country': attendeeinfo.country,
                'state': attendeeinfo.state,
                'city': attendeeinfo.city,
                'street': attendeeinfo.street,
                'zip': attendeeinfo.zip,
                'regid': attendeeinfo.regid,
                'regtype': attendeeinfo.regtype,
                'photo': attendeeinfo.photo,
                'memberid': attendeeinfo.memberid,
                'tag': 'tag',
                'ep': ' ',
                'submittedby': global.$regemail,
                'udate': timestamp.toString(),
                'visitpoints': attendeeinfo.vpoints,
                'activitypoints': attendeeinfo.apoints,
                'totalpoints': attendeeinfo.tpoints,
                'regstatus': regstatus,
                'sessionpoints': attendeeinfo.spoints,
                'poolid': attendeeinfo.poolid,
                'password': attendeeinfo.password,
                'myexpertise': attendeeinfo.myexpertise,
                'myinterests': attendeeinfo.myinterests,
                'validscans': attendeeinfo.validscans,
                'officephone': attendeeinfo.officephone,
                'currentlocation': moment.tz.guess(),
                'location': attendeeinfo.location,
                'locationtime': attendeeinfo.locationtime,
                'signindate': attendeeinfo.signindate,
                'lastseen': attendeeinfo.lastseen,
                'showdirectory': attendeeinfo.showdirectory.toString(),
                'purchasedate': timestamp.toString(),
                'itemnames': regitems,
                'amount': this.state.amountpaid.toString(),
                'orderid': this.state.orderid,
                'paymentid': this.state.paymentid,
                'signature': this.state.signature,
                'description': ' ',
                'paymenttype': global.$selectedPaymentOption,
                'promocode': promocode,
                'promoamount': promoamount.toString(),
                'totalamount': this.state.totalamount.toString(),
                'amountpaid': this.state.amountpaid.toString(),
                'paymentmode': global.$selectedPaymentOption,
                'promocodes': promocode,
                'guestname': this.state.guestname,
                'pendingamount': this.state.amountpending.toString(),
                'refundamount': '0',
                'mailstatus': mailstatus,
                'paymentuserid': global.$regemail,
                'reguser': user,
                'emailtype': emailtype,
                'paymentstatus': paymentstatus,
                'type': 'E',
                'etype': "D",
                'booth': " ",
                'category': category,
                'category1': attendeeinfo.service,
                'splevel': splevel,
                'logo': " ",
                'contact': attendeeinfo.fname + " " + attendeeinfo.lname,
                'cdate': timestamp.toString(),
                'id': regid,
                'keywords': " ",
                'url': attendeeinfo.url,
                'adfile': " ",
                'adsrc': " ",
                'auth': " ",
                'points': "0",
                'msg1': ' ',
                'msg2': ' ',
                'service': attendeeinfo.service,
                'desc': attendeeinfo.desc,
                'createdby': attendeeinfo.email,
                'sortorder': "0",
                'videourl': " ",
                'video1': " ",
                'video2': " ",
                'video3': " ",
                'image1': " ",
                'image2': " ",
                'image3': " ",
                'file1': " ",
                'file2': " ",
                'file3': " ",
                'meeting1': " ",
                'meeting2': " ",
                'meeting3': " ",
                'data1': attendeeinfo.data1,
                'data2': attendeeinfo.data2,
                'data3': attendeeinfo.data3,
                'data4': attendeeinfo.data4,
                'data5': dateregistered.toString(),
                'schedule': " ",
                "q1": this.state.q1,
                "q2": this.state.q2,
                "q3": this.state.q3,
                "q4": this.state.q4,
                "q5": this.state.q5,
                "q6": this.state.q6,
                "q7": this.state.q7,
                "q8": this.state.q8,
                "userstype": usertype,
                "guests": attendeeinfo.guests,
                "sessions": attendeeinfo.sessions,
                "regnotes": attendeeinfo.regnotes,
                "checkinstatus": attendeeinfo.checkinstatus,
                "mname": attendeeinfo.mname,
                "regitemsforsignupcount": global.$regItemsForSignupCount,
                "regpromocodesforsignupcount": regpromocodesforsignupcount,
                "registereditemstoreducesignupcount": global.$registereditems,
                "regitemtoreducecount": global.$regitemtoreducecount,
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        console.log(myInit);
        API.post(apiName, path, myInit).then(response => {
           //console.log(response);
            
           //response.data.status = false;

            if (response.data.status == true) {
                //console.log(global.$loginstatus);
                registered = true;
                if (CommonFunctions.isUserLoggedin()) {
                    //this.state.message = "You have successfully updated your registration";
                    //console.log(user);
                    if (user == "guest") {
                        //console.log("registered guest")
                    }
                    if (this.state.selectedpayment.includes("Card")) {
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${updatemsg}</p>`;
                        this.getRegStatus(user);
                        //this.props.hideRegisterButtonFromPaypal();
                    }
                    else {
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${updatemsg}</p>`;
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }

                    //console.log(myInit.body);
                    this.getAttendeeInfo(attendeeinfo.email, user);
                    //global.$loggedinuser = myInit.body;
                    global.$loggedinuserregitems = attendeeinfo.regtype;

                    //console.log(global.$loggedinuser);
                    //console.log(global.$loggedinuserregitems);

                }
                else {
                    //console.log(this.state.selectedpayment);
                    //console.log(response.data);
                    if (this.state.selectedpayment.includes("Check")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = "<p style='font-weight: bold'>" + successcheckmsg + "</p>";
                        ///this.setState({message : successcheckmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }
                    else if (this.state.selectedpayment.includes("Pay Later")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = "<p style='font-weight: bold'>" + successcheckmsg + "</p>";
                        ///this.setState({message : successcheckmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }
                    else if (this.state.selectedpayment.includes("Card")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successcardmsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successcardmsg});
                        
                        //console.log("hideRegisterButtonFromPaypal()");
                        this.getRegStatus(user);
                        //this.props.hideRegisterButtonFromPaypal(); Need to check for Stripe??
                    }
                    else if (this.state.selectedpayment.includes("Payroll")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successpayrollmsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successpayrollmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }
                    else if (this.state.selectedpayment.includes("ACH")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successachmsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successpayrollmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButtonFromACH();
                    }
                    else if (this.state.selectedpayment.includes("Pay Online")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successrazorpaymsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successpayrollmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButtonFromRazorpay();
                    }
                    else if (this.state.selectedpayment.includes("Free")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successfree}</p>`
                        //this.state.message = "Successfully registered for the conference, Please check your email for login details.";
                        //console.log(successfree);
                        //this.setState({message : successfree});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }

                }
                ///this.setState({ isLoading: false });
                //this.forceUpdate();
            }
            else {
                console.log(response);
                this.setState({ hideSpinner: true })
                
                // if(response.data.errorMessage == null){
                //     document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${response.data.message}</p>`;
                // }
                // else {
                //     document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${response.data.errorMessage}</p>`;
                // }
                //document.getElementById("message").innerHTML = `<p style='font-weight: bold'>Successfully registered</p>`;

                document.getElementById("message").innerHTML = `<p style='font-weight: bold'>Payment is processed but registration failed. Please contact support for further assistance.</p>`;    
            }

        }).catch(error => {
            console.log(error)
            this.setState({ hideSpinner: true })
            document.getElementById("message").innerHTML = `<p style='font-weight: bold'>Payment is processed but registration failed. Please contact support for further assistance.</p>`;    
    
        });

    }
    catch(e){
        console.log(e)
        this.setState({ hideSpinner: true })
        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>Payment is processed but registration failed. Please contact support for further assistance.</p>`;    
    }
    } //function
    

    getRegStatus(user) {
        if (user == "attendee") {
            global.$isattendeeregistered = true;
            if (global.$guestexist != null && global.$guestexist == true) {

            }
            else {
                
            }
            this.setState({
                attendeeregistration: true,
                hideSpinner: true
            });
            //this.setState({ regattendeesuccess: true });
        }
        else if (user == "guest") {
            //console.log("guest success");
            global.$isguestregistered = true;
            
            this.setState({
                guestregistration: true,
                hideSpinner: true
            });
            //this.setState({ regguestsuccess: true });
        }
    }

    getAttendeeInfo(userid, user) {
        let apiName = serviceNames.getUserService();
        let path = ''; //replace this with the path you have configured on your API
        let myInit = {
            body:
            {
                'command': 'getUserProfile',
                'code': global.$code,
                'userid': userid,
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        //console.log(myInit);

        API.post(apiName, path, myInit).then(response => {
            //console.log(response);
            if (response.err == null && response.data != null) {
                //console.log(response.data);
                let userObj = this.getUserObject(response.data.Item)
                //console.log(userObj);
                if (user == "attendee") {
                    global.$loggedinuser = userObj;
                    global.$regemail = userObj.userid;
                }
                else if (user == "guest") {
                    global.$loggedinguest = userObj;
                    global.$regguestemail = userObj.userid;
                    this.setState({ showtable: true })
                }
                else {
                }
                //console.log(global.$loggedinuser);
            }
            else {
                //console.log("getAttendeeInfo - updating state...")
                //console.log(response.err)
            }
        }
        ).catch(error => {
            //console.log(error)
        });
    }

    getUserObject(objs) {
        //var obj = objs[0] 
        //console.log(objs)

        var newObj = Object()

        newObj.userid = objs.userid.S
        newObj.fname = objs.fname.S
        newObj.lname = objs.lname.S
        newObj.photo = objs.photo.S
        newObj.company = objs.company.S
        newObj.phone = objs.phone.S
        newObj.title = objs.title.S
        newObj.email = objs.email.S
        newObj.country = objs.country.S
        newObj.state = objs.state.S
        newObj.street = objs.street.S
        newObj.city = objs.city.S
        newObj.state = objs.state.S
        newObj.zip = objs.zip.S
        newObj.linkedin = objs.linkedin.S
        newObj.twitter = objs.twitter.S
        newObj.fb = objs.fb.S
        newObj.regid = objs.regid.S
        newObj.regtype = objs.regtype.S
        newObj.memberid = objs.memberid.S
        newObj.visitpoints = objs.visitpoints.N
        newObj.activitypoints = objs.activitypoints.N
        newObj.totalpoints = objs.totalpoints.N
        newObj.sessionpoints = objs.sessionpoints.N
        newObj.regstatus = objs.regstatus.S
        newObj.password = objs.password.S
        newObj.myexpertise = objs.myexpertise.S
        newObj.myinterests = objs.myinterests.S
        newObj.validscans = objs.validscans.S
        newObj.currentlocation = objs.currentlocation.S
        newObj.lastseen = objs.lastseen.S
        newObj.showdirectory = objs.showdirectory.S
        newObj.officephone = objs.officephone.S
        newObj.location = objs.location.S
        newObj.locationtime = objs.locationtime.S
        newObj.signindate = objs.signindate.S
        newObj.data1 = objs.data1.S
        newObj.data2 = objs.data2.S
        newObj.data3 = objs.data3.S
        newObj.data4 = objs.data4.S
        newObj.data5 = objs.data5.S
        newObj.q1 = objs.q1.S
        newObj.q2 = objs.q2.S
        newObj.q3 = objs.q3.S
        newObj.q4 = objs.q4.S
        newObj.q5 = objs.q5.S
        newObj.q6 = objs.q6.S
        newObj.q7 = objs.q7.S
        newObj.q8 = objs.q8.S
        newObj.userstype = objs.userstype.S
        newObj.guests = objs.guests.S
        newObj.sessions = objs.sessions.S
        newObj.regnotes = objs.regnotes.S
        newObj.checkinstatus = objs.checkinstatus.S
        newObj.mname = objs.mname.S
        newObj.poolid = objs.poolid.S
        newObj.totalamount = objs.totalamount.N
        newObj.amountpaid = objs.amountpaid.N
        newObj.promoamount = objs.promoamount.N
        newObj.pendingamount = objs.pendingamount.N
        newObj.refundamount = objs.refundamount.N
        newObj.paymentmode = objs.paymentmode.S
        newObj.promocodes = objs.promocodes.S
        newObj.guestname = objs.guestname.S

        //console.log(newObj)
        //////console.log(newObj.category);

        return newObj
    }

    isTravconExhibitor(code) {
        var result = false;
        if (code == "travcon2022exhibitor" || code == "travcon2023exhibitor") {
            result = true;
        }
        return result;
    }
}
export default RegisterAttendee;



    /*
    addAttendee(attendeeinfo, user) {
        //console.log(this.state.guestregistration, this.state.reggueststatus, global.$isguestregistered)
        //console.log("adding =" + user);
        //console.log(attendeeinfo);
        //let apiName = 'WebsiteService';
        let apiName = serviceNames.getRegistrationService();
        let path = ''; //replace this with the path you have configured on your API

        var date = new Date();
        var longFormat = date / 1000;
        var timestamp = date / 1000;
        longFormat = longFormat.toString();
        longFormat = longFormat.replace(/\./g, "");
        //console.log(longFormat);
        //console.log(longFormat.length - 10, longFormat.length);
        var regid = longFormat.substring(longFormat.length - 10, longFormat.length);
        //console.log(regid);
        var password = regid;

        if (global.$code == "metro2022conference") {
            password = "MeTro2022";
        }

        if (global.$code == "metro2023convention") {
            password = "MeTro2023";
        }

        if (global.$code == "aicup2022") {
            password = "AiCuP2022";
        }

        if (global.$code == "aslatx2022") {
            password = "aslatx2022";
        }

        //console.log(global.$guestregitems.toString());
        //console.log(global.$attendeeregitems.toString());
        var regitems = '';
        //console.log(regitems);
        //console.log(user)
        if (user == "attendee") {
            this.setState({ attendeeregistration: "inprogress" });
            if (global.$guestexist == true && global.$guestfname != null) {
                this.state.guestname = global.$guestfname + " " + global.$guestlname;
            }
            //console.log(regitems);
            //console.log(global.$attendeeregitems)
            // Check to update the regitems
            if (global.$guestregitems != null && global.$regguestinfo != "") {
                if (global.$regdiscountinfo != null && global.$regdiscountinfo != "") {
                    if (global.$guestregitems != "" && global.$guestregitems != " ") {
                        regitems = global.$totalregitems.toString() + ",Promo or Deferral - $" + global.$regdiscountinfo.discountprice;
                        //console.log(regitems);
                    }
                    else {
                        regitems = global.$totalregitems.toString() + ",Promo or Deferral - $" + global.$regdiscountinfo.discountprice;
                        //console.log(regitems);
                    }
                }
                else {
                    if (CommonFunctions.isUserLoggedin()) {
                        if (global.$guestexist != null && global.$guestexist == true) {
                            regitems = global.$guestregitems.toString();
                        }
                        else {
                            regitems = global.$totalregitems.toString();
                        }
                        //console.log(regitems);
                    }
                    else {
                        regitems = global.$totalregitems.toString();
                        //console.log(regitems);
                    }
                }
            }
            else {
                if (global.$totalregitems != null) {

                    regitems = global.$totalregitems.toString();
                    //console.log(regitems);
                }
            }
        }
        else if (user == "guest") {
            //console.log(user)
            //console.log(global.$guestregitems)
            this.setState({ guestregistration: "inprogress" });
            regitems = global.$guestregitems.toString();
        }
        //console.log(regitems);

        if (attendeeinfo.fname == "") {
            attendeeinfo.fname = " ";
        }
        if (attendeeinfo.lname == "") {
            attendeeinfo.lname = " ";
        }
        if (attendeeinfo.phone == "") {
            attendeeinfo.phone = " ";
        }
        if (attendeeinfo.memberid == "") {
            attendeeinfo.memberid = " ";
        }
        if (attendeeinfo.company == "") {
            attendeeinfo.company = " ";
        }
        if (attendeeinfo.title == "") {
            attendeeinfo.title = " ";
        }
        if (attendeeinfo.officephone == "") {
            attendeeinfo.officephone = " ";
        }
        if (attendeeinfo.street == "") {
            attendeeinfo.street = " ";
        }
        if (attendeeinfo.city == "") {
            attendeeinfo.city = " ";
        }
        if (attendeeinfo.zip == "") {
            attendeeinfo.zip = " ";
        }
        if (attendeeinfo.state == "") {
            attendeeinfo.state = " ";
        }
        if (attendeeinfo.country == "") {
            attendeeinfo.country = " ";
        }
        if (attendeeinfo.location == "" || attendeeinfo.location == null) {
            //console.log(moment.tz.guess());
            attendeeinfo.location = moment.tz.guess();
        }
        if (attendeeinfo.linkedin == "") {
            attendeeinfo.linkedin = " ";
        }
        if (attendeeinfo.facebook == "") {
            attendeeinfo.facebook = " ";
        }
        if (attendeeinfo.twitter == "") {
            attendeeinfo.twitter = " ";
        }
        if (attendeeinfo.myexpertise == "") {
            attendeeinfo.myexpertise = " ";
        }
        if (attendeeinfo.myinterests == "") {
            attendeeinfo.myinterests = " ";
        }
        if (attendeeinfo.data1 == "") {
            attendeeinfo.data2 = " ";
        }
        if (attendeeinfo.data3 == "") {
            attendeeinfo.data3 = " ";
        }
        if (attendeeinfo.lastseen == "") {
            attendeeinfo.lastseen = " ";
        }
        if (attendeeinfo.poolid == "" || attendeeinfo.poolid == null) {
           //console.log(global.$settings)
            attendeeinfo.poolid = global.$settings.poolids.userpoolid;
        }
        if (attendeeinfo.submittedby == "") {
            attendeeinfo.submittedby = " ";
        }
        if (attendeeinfo.validscans == "") {
            attendeeinfo.validscans = " ";
        }
        if (attendeeinfo.password == "") {
            attendeeinfo.password = password;
        }
        if (attendeeinfo.regid == "") {
            attendeeinfo.regid = regid;
        }
        if (attendeeinfo.regid == "") {
            attendeeinfo.regid = regid;
        }
        if (attendeeinfo.regtype == "") {
            attendeeinfo.regtype = regitems;
        }
        if (attendeeinfo.mname == "") {
            attendeeinfo.mname = " ";
        }
        if (attendeeinfo.locationtime == "") {
            attendeeinfo.locationtime = moment.tz(attendeeinfo.location).format('mm/dd/yyyy hh:mm:ss A');
        }
        if (attendeeinfo.signindate == "") {
            attendeeinfo.signindate = " ";
        }
        //console.log(global.$reguestemail);
        //console.log(global.$guestexist, global.$reguestemail)
        //console.log(attendeeinfo);
        if (attendeeinfo.guests == "" || attendeeinfo.guests == " ") {
            //console.log(global.$guestexist, global.$reguestemail)
            if (user == "attendee") {
                if (global.$guestexist == true) {
                    //console.log(global.$guestexist, global.$reguestemail)
                    if (global.$reguestemail != null) {
                        //console.log(global.$guestexist, global.$reguestemail)
                        attendeeinfo.guests = global.$reguestemail;
                    }
                    else {
                        attendeeinfo.guests = " ";
                    }
                }
            }
        }
        //console.log(attendeeinfo);
        if (attendeeinfo.sessions == "") {
            attendeeinfo.sessions = " ";
        }
        if (attendeeinfo.checkinstatus == "") {
            attendeeinfo.checkinstatus = " ";
        }
        if (attendeeinfo.regnotes == "") {
            attendeeinfo.regnotes = " ";
        }
        if (attendeeinfo.photo == "") {
            attendeeinfo.photo = "common_profile.png";
        }


        // Check to update the question fields
        if (global.$regquestionsinfo != null) {
            if (global.$regquestionsinfo.question1 == "Select") {
                global.$regquestionsinfo.question1 = " ";
            }
            if (global.$regquestionsinfo.question2 == "Select") {
                global.$regquestionsinfo.question2 = " ";
            }
            if (global.$regquestionsinfo.question3 == "Select") {
                global.$regquestionsinfo.question3 = " ";
            }
            if (global.$regquestionsinfo.question4 == "Select") {
                global.$regquestionsinfo.question4 = " ";
            }
            if (global.$regquestionsinfo.question5 == "Select") {
                global.$regquestionsinfo.question5 = " ";
            }
            if (global.$regquestionsinfo.question6 == "Select") {
                global.$regquestionsinfo.question6 = " ";
            }
            if (global.$regquestionsinfo.question7 == "Select") {
                global.$regquestionsinfo.question7 = " ";
            }
            if (global.$regquestionsinfo.question8 == "Select") {
                global.$regquestionsinfo.question8 = " ";
            }
            if (global.$regquestionsinfo.question1 != "" && global.$regquestionsinfo.question1value == "") {
                this.state.q1 = 'q#title:' + global.$regquestionsinfo.question1title + ';answer:' + global.$regquestionsinfo.question1;
                if (global.$code == "wspma2021") {
                    //console.log(global.$regquestionsinfo.question1);
                    if (global.$regquestionsinfo.question1 == "Yes") {
                        this.state.showdirectory = "true";
                    }
                    else {
                        this.state.showdirectory = "false";
                    }
                    //console.log(this.state.showdirectory)
                }
            }
            else if (global.$regquestionsinfo.question1value != "") {
                this.state.q1 = 'q#title:' + global.$regquestionsinfo.question1title + ';answer:' + global.$regquestionsinfo.question1value;
            }

            if (global.$regquestionsinfo.question2 != "" && global.$regquestionsinfo.question2value == "") {
                this.state.q2 = 'q#title:' + global.$regquestionsinfo.question2title + ';answer:' + global.$regquestionsinfo.question2;
            }
            else if (global.$regquestionsinfo.question2value != "") {
                this.state.q2 = 'q#title:' + global.$regquestionsinfo.question2title + ';answer:' + global.$regquestionsinfo.question2value;
            }

            if (global.$regquestionsinfo.question3 != "" && global.$regquestionsinfo.question3value == "") {
                this.state.q3 = 'q#title:' + global.$regquestionsinfo.question3title + ';answer:' + global.$regquestionsinfo.question3;
            }
            else if (global.$regquestionsinfo.question3value != "") {
                this.state.q3 = 'q#title:' + global.$regquestionsinfo.question3title + ';answer:' + global.$regquestionsinfo.question3value;
            }

            if (global.$regquestionsinfo.question4 != "" && global.$regquestionsinfo.question4value == "") {
                this.state.q4 = 'q#title:' + global.$regquestionsinfo.question4title + ';answer:' + global.$regquestionsinfo.question4;
            }
            else if (global.$regquestionsinfo.question4value != "") {
                this.state.q4 = 'q#title:' + global.$regquestionsinfo.question4title + ';answer:' + global.$regquestionsinfo.question4value;
            }

            if (global.$regquestionsinfo.question5 != "" && global.$regquestionsinfo.question5value == "") {
                this.state.q5 = 'q#title:' + global.$regquestionsinfo.question5title + ';answer:' + global.$regquestionsinfo.question5;
            }
            else if (global.$regquestionsinfo.question5value != "") {
                this.state.q5 = 'q#title:' + global.$regquestionsinfo.question5title + ';answer:' + global.$regquestionsinfo.question5value;
            }

            if (global.$regquestionsinfo.question6 != "" && global.$regquestionsinfo.question6value == "") {
                this.state.q6 = 'q#title:' + global.$regquestionsinfo.question6title + ';answer:' + global.$regquestionsinfo.question6;
            }
            else if (global.$regquestionsinfo.question6value != "") {
                this.state.q6 = 'q#title:' + global.$regquestionsinfo.question6title + ';answer:' + global.$regquestionsinfo.question6value;
            }

            if (global.$regquestionsinfo.question7 != "" && global.$regquestionsinfo.question7value == "") {
                this.state.q7 = 'q#title:' + global.$regquestionsinfo.question7title + ';answer:' + global.$regquestionsinfo.question7;
            }
            else if (global.$regquestionsinfo.question7value != "") {
                this.state.q7 = 'q#title:' + global.$regquestionsinfo.question7title + ';answer:' + global.$regquestionsinfo.question7value;
            }

            if (global.$regquestionsinfo.question8 != "" && global.$regquestionsinfo.question8value == "") {
                this.state.q8 = 'q#title:' + global.$regquestionsinfo.question8title + ';answer:' + global.$regquestionsinfo.question8;
            }
            else if (global.$regquestionsinfo.question8value != "") {
                this.state.q8 = 'q#title:' + global.$regquestionsinfo.question8title + ';answer:' + global.$regquestionsinfo.question8value;
            }
        }
        var mailstatus = "new";
        var regstatus = 'Confirmed';
        var emailtype = '';
        var paymentstatus = '';


        // check to update the payment and regtype fields
        if (CommonFunctions.isUserLoggedin()) {
            mailstatus = 'update';

            var commonstrings = RegItemStrings.commonConstants;
            //console.log(commonstrings);
            if (user == "attendee") {
                //console.log(global.$regamount, attendeeinfo.totalamount, Number(global.$regamount), Number(attendeeinfo.totalamount))
                this.state.totalamount = Number(global.$regamount) + Number(attendeeinfo.totalamount);
                this.state.refundamount = Number(attendeeinfo.refundamount);
                this.state.amountpending = Number(attendeeinfo.pendingamount);
                this.state.amountpaid = Number(attendeeinfo.amountpaid);
                //console.log(this.state.totalamount);
                //console.log(attendeeinfo.regtype);
                //console.log(regitems);

                // add the new regitems to the old regitems
                if (regitems.includes("Booth Registration") || regitems.includes("Booth Bundle Registration")) {
                    var result = TravconFunctions.replaceRegItemsForRegUpgrade(global.$code, attendeeinfo.regtype, regitems);
                   //console.log(result);
                    var upgrade = "Booth Upgrade - $" + global.$upgradepricediff;

                    regitems = regitems + "," + upgrade;

                    attendeeinfo.regtype = result + "," + regitems;
                }
                else if (regitems.includes(commonstrings.mainstageticket) || regitems.includes(commonstrings.newbiebootcamp) || regitems.includes(commonstrings.medicalspanishsun) || regitems.includes(commonstrings.medicalspanishwed) ||  regitems.includes(commonstrings.travcon2023medicalspanishsun) || regitems.includes(commonstrings.travcon2023medicalspanishwed)) {
                    var result = TravconFunctions.replaceRegItemsForRegUpgrade(global.$code, attendeeinfo.regtype, regitems);
                    //console.log(result);
                    //console.log(regitems);
                    var upgrade = "Upgrade - $" + global.$upgradepricediff;

                    regitems = regitems + "," + upgrade;

                    attendeeinfo.regtype = result + "," + regitems;
                }
                else {
                    //console.log(regitems);
                    attendeeinfo.regtype = attendeeinfo.regtype + "," + regitems;
                }
                //console.log(attendeeinfo.regtype);
                //console.log(global.$selectedPaymentOption,global.$regamount, global.$deferredpromo, global.$deferredpromoamount, this.state.amountpending);
                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                        if (global.$deferredpromoamount != null) {
                            if (global.$code == "travcon2022exhibitor" || global.$code == "travcon2023exhibitor") {
                                this.state.amountpending = Number(global.$deferredpromoamount);
                            }
                            else {
                                this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                            }
                        }
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                    if (regitems == "" || regitems == " ") {
                        this.state.amountpending = Number(attendeeinfo.pendingamount);
                    }
                    else {
                        this.state.amountpending = Number(global.$regamount);
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                    if (regitems == "" || regitems == " ") {
                        this.state.amountpending = Number(attendeeinfo.pendingamount);
                    }
                    else {
                        this.state.amountpending = Number(global.$regamount);
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                    //console.log("regitems: " + regitems);
                    if (regitems == "" || regitems == " ") {
                        this.state.amountpending = Number(attendeeinfo.pendingamount);
                    }
                    else {
                        this.state.amountpending = Number(global.$regamount);
                    }

                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            if (global.$code == "travcon2022exhibitor" || global.$code == "travcon2023exhibitor") {
                                this.state.amountpending = Number(global.$deferredpromoamount);
                            }
                            else {
                                this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                            }
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("ACH")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            if (global.$code == "travcon2022exhibitor" || global.$code == "travcon2023exhibitor") {
                                this.state.amountpending = Number(global.$deferredpromoamount);
                            }
                            else {
                                this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                            }
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Online")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = Number(global.$deferredpromoamount) + Number(attendeeinfo.pendingamount);
                        }
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = Number(global.$regamount) + Number(attendeeinfo.amountpaid);
                    }
                }
            }
            else if (user == "guest") {
                this.state.totalamount = Number(attendeeinfo.totalamount);
                this.state.refundamount = Number(attendeeinfo.refundamount);
                this.state.amountpending = Number(attendeeinfo.pendingamount);
                this.state.amountpaid = Number(attendeeinfo.amountpaid);
                //console.log(regitems);
                //console.log(attendeeinfo);
                attendeeinfo.regtype = regitems;
                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
            }
        }
        else {
            if (user == "attendee") {
                //this.state.totalamount = global.$totalamount
                //console.log(global.$regamount, attendeeinfo.totalamount, Number(global.$regamount), Number(attendeeinfo.totalamount))

                //console.log(this.state.totalamount);
                this.state.totalamount = global.$regamount

                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                    this.state.amountpaid = 0;
                    this.state.amountpending = global.$regamount;
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                    this.state.amountpaid = 0;
                    this.state.amountpending = global.$regamount;
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                    this.state.amountpaid = 0;
                    this.state.amountpending = global.$regamount;
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("ACH")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Online")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        this.state.amountpending = 0;
                        if (global.$deferredpromoamount != null) {
                            this.state.amountpending = global.$deferredpromoamount;
                        }
                        this.state.amountpaid = global.$regamount;
                    }
                    else {
                        paymentstatus = "paid";
                        this.state.amountpaid = global.$regamount;
                        this.state.amountpending = 0;
                    }
                }
            }
            else if (user == "guest") {

                this.state.amountpaid = 0;
                this.state.amountpending = 0;
                this.state.totalamount = 0;
                if (global.$regamount == 0) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                        regstatus = "Confirmed";
                    }
                    else {
                        paymentstatus = "free";
                        regstatus = "Confirmed";    // free registration
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Check")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Pay Later")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Payroll")) {
                    paymentstatus = "pending";
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Credit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
                else if (global.$regamount != 0 && global.$selectedPaymentOption.includes("Debit")) {
                    if (global.$deferredpromo == "Y") {
                        paymentstatus = "pending";
                    }
                    else {
                        paymentstatus = "paid";
                    }
                }
            }
        }

        // Check to update the regstatus
        if (global.$selectedPaymentOption.includes("Check") || global.$selectedPaymentOption.includes("Payroll") || global.$selectedPaymentOption.includes("Pay Later")) {
            regstatus = "Pending";
        }
        else {
            if (global.$deferredpromo == "Y") {
                regstatus = "Confirmed";
            }
            else {
                regstatus = "Confirmed";
            }
        }


        //console.log(user, this.props.type);
        //console.log(attendeeinfo);
        var usertype = "attendee";
        if (user == "attendee") {
            if (this.props.type == "attendee") {
                emailtype = "primaryattendee";
                usertype = "Attendee";
            }
            else if (this.props.type == "sponsor") {
                emailtype = "primarysponsor";
                usertype = "Sponsor";
                //usertype = "Exhibitor";
            }
            else if (this.props.type == "exhibitor") {
                emailtype = "primaryexhibitor";
                //usertype = "Sponsor";
                usertype = "Exhibitor";
                
                if(attendeeinfo.userstype == "Exhibitor Admin"){
                    usertype = "Exhibitor Admin";
                }
            }
        }
        else if (user == "guest") {
            if (this.props.type == "attendee") {
                emailtype = "primaryguest";
                usertype = "Guest"
            }
            else if (this.props.type == "sponsor") {
                emailtype = "guestsponsor";
                //usertype = "Sponsor";
                usertype = "Exhibitor";
            }
            else if (this.props.type == "exhibitor") {
                emailtype = "primaryexhibitor";
                //usertype = "Sponsor";
                usertype = "Exhibitor";

                if(attendeeinfo.userstype == "Exhibitor Admin"){
                    usertype = "Exhibitor Admin";
                }

            }
        }
        //console.log(usertype)
        if (global.$regamount == 0) {
            global.$selectedPaymentOption = "No Payment";
            if (user == "attendee") {
                if (global.$deferredpromo == "N") {
                    regstatus = "Pending"
                }
            }

        }

        var promocode = ' ';
        var promoamount = '0';
        var regpromocodesforsignupcount = "";
        //console.log(global.$regdiscountinfo);
        //console.log(promocode);
        if (global.$regdiscountinfo != null && global.$regdiscountinfo != "" && global.$regdiscountinfo != " ") {
            if (global.$regdiscountinfo.discountvalue != null) {
                promocode = global.$regdiscountinfo.discountvalue;
                regpromocodesforsignupcount = global.$regdiscountinfo.discountvalue;
            }
            if (global.$regdiscountinfo.discountprice != null) {
                if (global.$deferredpromo != "Y") {
                    promoamount = global.$regdiscountinfo.discountprice;
                }
            }
        }

        if (CommonFunctions.isUserLoggedin()) {
            if (user == "attendee") {
                regstatus = attendeeinfo.regstatus;
                if (attendeeinfo.promocodes != null && attendeeinfo.promocodes != "" && attendeeinfo.promocodes != " ") {
                    attendeeinfo.promocodes = attendeeinfo.promocodes.trim();
                    promocode = attendeeinfo.promocodes + "," + promocode;
                }
                promoamount = Number(attendeeinfo.promoamount) + Number(promoamount);
            }
        }
        else {
            if (global.$deferredpromo == "Y") {
                regstatus = "Confirmed";
            }
        }
        //console.log(attendeeinfo.showdirectory)
        this.state.showdirectory = attendeeinfo.showdirectory
        //console.log(this.state.showdirectory);
        if (this.state.showdirectory == " ") {
            this.state.showdirectory = "true";
        }
        //console.log(promocode);

        if (attendeeinfo.data1 == "") {
            attendeeinfo.data1 = " ";
        }
        if (attendeeinfo.data2 == "") {
            attendeeinfo.data2 = " ";
        }
        if (attendeeinfo.data3 == "") {
            attendeeinfo.data3 = " ";
        }
        if (attendeeinfo.data4 == "") {
            attendeeinfo.data4 = " ";
        }
        if (attendeeinfo.data5 == "") {
            attendeeinfo.data5 = " ";
        }
        if (attendeeinfo.service == "") {
            attendeeinfo.service = " ";
        }
        if (attendeeinfo.desc == "") {
            attendeeinfo.desc = " ";
        }
        if (attendeeinfo.guests == "") {
            attendeeinfo.guests = " ";
        }
        if (this.state.guestname == "") {
            this.state.guestname = " ";
        }
        if (attendeeinfo.url == "") {
            attendeeinfo.url = " ";
        }

        if (user == "guest") {
            promoamount = '0';
            promocode = " ";
            this.state.guestname = " ";
        }


        /// Added this check for metro automatic badge In-Person/Virtual
        if (CommonFunctions.isUserLoggedin()) {
            if (user == "guest") {
                if (global.$guestregitems.toString().includes("In-Person")) {
                    attendeeinfo.data4 = "In-Person";
                }
                else if (global.$guestregitems.toString().includes("Virtual")) {
                    attendeeinfo.data4 = "Virtual";
                }
            }
        }
        else {

            if (user == "attendee") {
                if (global.$attendeeregitems.toString().includes("In-Person")) {
                    attendeeinfo.data4 = "In-Person";
                }
                else if (global.$attendeeregitems.toString().includes("Virtual")) {
                    attendeeinfo.data4 = "Virtual";
                }
            }
            else if (user == "guest") {
                if (global.$guestregitems.toString().includes("In-Person")) {
                    attendeeinfo.data4 = "In-Person";
                }
                else if (global.$guestregitems.toString().includes("Virtual")) {
                    attendeeinfo.data4 = "Virtual";
                }
            }
        }
        attendeeinfo.email = (attendeeinfo.email).trim();
        attendeeinfo.email = (attendeeinfo.email).toLowerCase();

        global.$regemail = (global.$regemail).trim();
        global.$regemail = (global.$regemail).toLowerCase();

        if (paymentstatus == "free") {
            regstatus = "Confirmed";
        }
        //console.log(promoamount)

        // if (promoamount == 0) {
        //     promocode = " ";
        // }
        var dateregistered = new Date(timestamp * 1000).toLocaleString();

        if (CommonFunctions.isUserLoggedin()) {
            dateregistered = attendeeinfo.data5;
        }
        //console.log(dateregistered);
        //console.log(global.$regamount, global.$code, global.$selectedPaymentOption); 
        if (global.$transactionfee != null && global.$transactionfee != "" && global.$regamount > 0 && this.isTravconExhibitor(global.$code) && global.$selectedPaymentOption.includes("Credit")) {
            regitems = regitems + ",Transaction Fee - $" + global.$transactionfee;
            attendeeinfo.regtype = attendeeinfo.regtype + ",Transaction Fee - $" + global.$transactionfee;
        }

        var category = regitems;
        var splevel = regitems;
        if (this.props.type == "exhibitor" || this.props.type == "sponsor") {
            category = " ";
            splevel = " "
        }
        // if (Number(this.state.totalamount) == Number(0)) {
        //    //console.log(this.state.totalamount);
        //     this.state.totalamount = global.$totalamount;
        //    //console.log(this.state.totalamount);
        // }
        //console.log(this.state.totalamount);
        this.state.totalamount = parseFloat(this.state.totalamount).toFixed(2);
        //console.log(this.state.totalamount);
        this.state.amountpaid = parseFloat(this.state.amountpaid).toFixed(2);
        this.state.amountpending = parseFloat(this.state.amountpending).toFixed(2);
        promoamount = parseFloat(promoamount).toFixed(2);

        if (global.$code == "afpikar2021") {
            if (global.$paymentid != null) {
                this.state.paymentid = global.$paymentid;
            }
        }
        //console.log(attendeeinfo)
        if(EventcodeFunctions.isTravconAttendee(global.$code) && user == "attendee"){
            this.state.guestname = attendeeinfo.guestname;
        }
        //console.log(attendeeinfo)
        if (global.$regitemtoreducecount == null) {
            global.$regitemtoreducecount = "";
        }
        let myInit =
        {
            body:
            {
                'code': global.$code,
                // 'command': 'addUserProfile',
                'command': 'processRegistration',
                'userid': attendeeinfo.email,
                'fname': attendeeinfo.fname,
                'lname': attendeeinfo.lname,
                'company': attendeeinfo.company,
                'title': attendeeinfo.title,
                'phone': attendeeinfo.phone,
                'email': attendeeinfo.email,
                'linkedin': attendeeinfo.linkedin,
                'twitter': attendeeinfo.twitter,
                'fb': attendeeinfo.facebook,
                'country': attendeeinfo.country,
                'state': attendeeinfo.state,
                'city': attendeeinfo.city,
                'street': attendeeinfo.street,
                'zip': attendeeinfo.zip,
                'regid': attendeeinfo.regid,
                'regtype': attendeeinfo.regtype,
                'photo': attendeeinfo.photo,
                'memberid': attendeeinfo.memberid,
                'tag': 'tag',
                'ep': ' ',
                'submittedby': global.$regemail,
                'udate': timestamp.toString(),
                'visitpoints': attendeeinfo.vpoints,
                'activitypoints': attendeeinfo.apoints,
                'totalpoints': attendeeinfo.tpoints,
                'regstatus': regstatus,
                'sessionpoints': attendeeinfo.spoints,
                'poolid': attendeeinfo.poolid,
                'password': attendeeinfo.password,
                'myexpertise': attendeeinfo.myexpertise,
                'myinterests': attendeeinfo.myinterests,
                'validscans': attendeeinfo.validscans,
                'officephone': attendeeinfo.officephone,
                'currentlocation': moment.tz.guess(),
                'location': attendeeinfo.location,
                'locationtime': attendeeinfo.locationtime,
                'signindate': attendeeinfo.signindate,
                'lastseen': attendeeinfo.lastseen,
                'showdirectory': attendeeinfo.showdirectory.toString(),
                'purchasedate': timestamp.toString(),
                'itemnames': regitems,
                'amount': this.state.amountpaid.toString(),
                'orderid': this.state.orderid,
                'paymentid': this.state.paymentid,
                'signature': this.state.signature,
                'description': ' ',
                'paymenttype': global.$selectedPaymentOption,
                'promocode': promocode,
                'promoamount': promoamount.toString(),
                'totalamount': this.state.totalamount.toString(),
                'amountpaid': this.state.amountpaid.toString(),
                'paymentmode': global.$selectedPaymentOption,
                'promocodes': promocode,
                'guestname': this.state.guestname,
                'pendingamount': this.state.amountpending.toString(),
                'refundamount': '0',
                'mailstatus': mailstatus,
                'paymentuserid': global.$regemail,
                'reguser': user,
                'emailtype': emailtype,
                'paymentstatus': paymentstatus,
                'type': 'E',
                'etype': "D",
                'booth': " ",
                'category': category,
                'category1': attendeeinfo.service,
                'splevel': splevel,
                'logo': " ",
                'contact': attendeeinfo.fname + " " + attendeeinfo.lname,
                'cdate': timestamp.toString(),
                'id': regid,
                'keywords': " ",
                'url': attendeeinfo.url,
                'adfile': " ",
                'adsrc': " ",
                'auth': " ",
                'points': "0",
                'msg1': ' ',
                'msg2': ' ',
                'service': attendeeinfo.service,
                'desc': attendeeinfo.desc,
                'createdby': attendeeinfo.email,
                'sortorder': "0",
                'videourl': " ",
                'video1': " ",
                'video2': " ",
                'video3': " ",
                'image1': " ",
                'image2': " ",
                'image3': " ",
                'file1': " ",
                'file2': " ",
                'file3': " ",
                'meeting1': " ",
                'meeting2': " ",
                'meeting3': " ",
                'data1': attendeeinfo.data1,
                'data2': attendeeinfo.data2,
                'data3': attendeeinfo.data3,
                'data4': attendeeinfo.data4,
                'data5': dateregistered.toString(),
                'schedule': " ",
                "q1": this.state.q1,
                "q2": this.state.q2,
                "q3": this.state.q3,
                "q4": this.state.q4,
                "q5": this.state.q5,
                "q6": this.state.q6,
                "q7": this.state.q7,
                "q8": this.state.q8,
                "userstype": usertype,
                "guests": attendeeinfo.guests,
                "sessions": attendeeinfo.sessions,
                "regnotes": attendeeinfo.regnotes,
                "checkinstatus": attendeeinfo.checkinstatus,
                "mname": attendeeinfo.mname,
                "regitemsforsignupcount": global.$regItemsForSignupCount,
                "regpromocodesforsignupcount": regpromocodesforsignupcount,
                "registereditemstoreducesignupcount": global.$registereditems,
                "regitemtoreducecount": global.$regitemtoreducecount,
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
       //console.log(myInit);

        API.post(apiName, path, myInit).then(response => {
           console.log(response);
            
           //response.data.status = false;

            if (response.data.status == true) {
                //console.log(global.$loginstatus);
                registered = true;
                if (CommonFunctions.isUserLoggedin()) {
                    //this.state.message = "You have successfully updated your registration";
                    //console.log(user);
                    if (user == "guest") {
                        //console.log("registered guest")
                    }
                    if (this.state.selectedpayment.includes("Card")) {
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${updatemsg}</p>`;
                        this.getRegStatus(user);
                        this.props.hideRegisterButtonFromPaypal();
                    }
                    else {
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${updatemsg}</p>`;
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }

                    //console.log(myInit.body);
                    this.getAttendeeInfo(attendeeinfo.email, user);
                    //global.$loggedinuser = myInit.body;
                    global.$loggedinuserregitems = attendeeinfo.regtype;

                    //console.log(global.$loggedinuser);
                    //console.log(global.$loggedinuserregitems);

                }
                else {
                    //console.log(this.state.selectedpayment);
                    //console.log(response.data);
                    if (this.state.selectedpayment.includes("Check")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = "<p style='font-weight: bold'>" + successcheckmsg + "</p>";
                        ///this.setState({message : successcheckmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }
                    else if (this.state.selectedpayment.includes("Pay Later")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = "<p style='font-weight: bold'>" + successcheckmsg + "</p>";
                        ///this.setState({message : successcheckmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }
                    else if (this.state.selectedpayment.includes("Card")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successcardmsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successcardmsg});
                        
                        //console.log("hideRegisterButtonFromPaypal()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButtonFromPaypal();
                    }
                    else if (this.state.selectedpayment.includes("Payroll")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successpayrollmsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successpayrollmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }
                    else if (this.state.selectedpayment.includes("ACH")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successachmsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successpayrollmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButtonFromACH();
                    }
                    else if (this.state.selectedpayment.includes("Pay Online")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successrazorpaymsg}</p>`;
                        //this.state.message = "You have successfully submitted your details and registration is on hold, please submit your check and confirm registration";
                        //this.setState({message : successpayrollmsg});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButtonFromRazorpay();
                    }
                    else if (this.state.selectedpayment.includes("Free")) {
                        //console.log(this.state.selectedpayment);
                        document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${successfree}</p>`
                        //this.state.message = "Successfully registered for the conference, Please check your email for login details.";
                        //console.log(successfree);
                        //this.setState({message : successfree});
                        
                        //console.log("hideRegisterButton()");
                        this.getRegStatus(user);
                        this.props.hideRegisterButton();
                    }

                }
                ///this.setState({ isLoading: false });
                //this.forceUpdate();
            }
            else {
                console.log(response);
                this.setState({ hideSpinner: true })
                
                // if(response.data.errorMessage == null){
                //     document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${response.data.message}</p>`;
                // }
                // else {
                //     document.getElementById("message").innerHTML = `<p style='font-weight: bold'>${response.data.errorMessage}</p>`;
                // }
                //document.getElementById("message").innerHTML = `<p style='font-weight: bold'>Successfully registered</p>`;

                document.getElementById("message").innerHTML = `<p style='font-weight: bold'>Payment is processed but registration failed. Please contact support for further assistance.</p>`;    
            }

        }).catch(error => {
            console.log(error)
        });
    }
    */